// Lazily loads Cloudflare Turnstile and obtains an invisible assessment token
// immediately before booking-intent creation. No npm dependency — Turnstile
// is a vanilla script the API doesn't proxy or bundle for us.
const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js";
let scriptLoadPromise = null;
function loadScript() {
    if (window.turnstile)
        return Promise.resolve();
    if (scriptLoadPromise)
        return scriptLoadPromise;
    scriptLoadPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Failed to load Turnstile"));
        document.head.appendChild(script);
    });
    return scriptLoadPromise;
}
export function useTurnstile() {
    async function getAssessment(siteKey, action) {
        await loadScript();
        if (!window.turnstile)
            throw new Error("Turnstile failed to initialize");
        return new Promise((resolve, reject) => {
            const container = document.createElement("div");
            container.style.display = "none";
            document.body.appendChild(container);
            const widgetId = window.turnstile.render(container, {
                sitekey: siteKey,
                action,
                size: "invisible",
                callback: (token) => {
                    window.turnstile.remove(widgetId);
                    container.remove();
                    resolve(token);
                },
                "error-callback": () => {
                    window.turnstile.remove(widgetId);
                    container.remove();
                    reject(new Error("Turnstile assessment failed"));
                },
            });
        });
    }
    return { getAssessment };
}
